import { compose } from "redux";
import classNames from "classnames";
import { connect } from "react-redux";
import React, { PureComponent } from "react";
import Group from "@material-ui/icons/Group";
import { green, red, yellow } from "@material-ui/core/colors";
import { withStyles, CircularProgress, ButtonBase } from "@material-ui/core";

import {
  ACTIONS,
  GROUP_TYPES,
  GROUP_FLAG_TYPES,
} from "features/planner/planner.constants";

import OilRigIcon from "features/planner/components/OilRigIcon";
import { getActionDataStateFromState } from "app/app.selectors";
import { updateGroupFlagType } from "features/planner/planner.actions";
import SortableListRowIcon from "app/components/SortableList/SortableListRowIcon";

class GroupFlagTypeBtn extends PureComponent {
  updateGroupFlagType = () => {
    const { dispatchUpdateGroupFlagType, group } = this.props;

    // cycle through flag types in the reverse order of their values, i.e. red -> yellow -> green -> none
    const numberOfGroupFlagTypes = Object.keys(GROUP_FLAG_TYPES).length;
    dispatchUpdateGroupFlagType(
      group.get("id"),
      (group.get("flagType") - 1 + numberOfGroupFlagTypes) %
        numberOfGroupFlagTypes,
    );
  };

  render() {
    const { classes, group, dataState, disabled } = this.props;

    return (
      <SortableListRowIcon
        transparent
        disabled={disabled}
        component={ButtonBase}
        title={"Change flag type"}
        onClick={this.updateGroupFlagType}
        classes={{
          iconColumn: classNames(
            classes.iconColumn,
            classes[group.get("flagType")],
          ),
        }}
      >
        {dataState.isLoading() && (
          <CircularProgress size={20} color="secondary" />
        )}
        {!dataState.isLoading() &&
          group.get("type") === GROUP_TYPES.LOCATION_GROUP && (
            <OilRigIcon
              classes={{
                root: classes.groupIcon,
              }}
            />
          )}
        {!dataState.isLoading() &&
          group.get("type") === GROUP_TYPES.PLANNING_GROUP && (
            <Group color="secondary" />
          )}
      </SortableListRowIcon>
    );
  }
}

const styles = theme => ({
  groupIcon: {
    width: theme.altus.row.height,
    height: theme.altus.row.height,
  },
  iconColumn: {
    height: 40,
    width: 40,
    minWidth: 40,
  },
  [GROUP_FLAG_TYPES.NONE]: {
    "&:hover": {
      background: theme.palette.primary.light,
    },
  },
  [GROUP_FLAG_TYPES.GREEN]: {
    background: green[700],
    "&:hover": {
      background: green[500],
    },
  },
  [GROUP_FLAG_TYPES.YELLOW]: {
    background: yellow[800],
    "&:hover": {
      background: yellow[600],
    },
  },
  [GROUP_FLAG_TYPES.RED]: {
    background: red[800],
    "&:hover": {
      background: red[600],
    },
  },
});

export default compose(
  connect(
    (state, { group }) => ({
      dataState: getActionDataStateFromState(
        state,
        ACTIONS.GROUP_LOADED,
        group.get("id"),
      ),
    }),
    {
      dispatchUpdateGroupFlagType: updateGroupFlagType,
    },
  ),
  withStyles(styles),
)(GroupFlagTypeBtn);
